module.exports = __webpack_public_path__ + "static/img/stuhand.e74e093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/stuhand.png
// module id = HtW0
// module chunks = 0